export default __webpack_public_path__ + "static/media/paraphrase.fca74423.png";